import moment, { Moment } from 'moment-timezone';

export function isNullOrUndefined(object: any): boolean {
  return object === null || object === undefined;
}

export function extractUrlParam(name, url): string {
  if (!isNullOrUndefined(name) && !isNullOrUndefined(url)) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    const regexS = '[\\?&]' + name + '=([^&#]*)';
    const regex = new RegExp(regexS);
    const results = regex.exec(url);
    return results === null ? null : results[1];
  } else {
    return null;
  }
}

export function countDecimals(number: number) {
  if (Math.floor(number.valueOf()) === number.valueOf()) {
    return 0;
  }

  return number.toString().split('.')[1].length || 0;
}

/**
 * Safely access deeply nested values in an object
 *
 * For example with this object:
  ```
  const props = {
    user: {
      posts: [
        { title: 'Foo', comments: [ 'Good one!', 'Interesting...' ] },
        { title: 'Bar', comments: [ 'Ok' ] },
        { title: 'Baz', comments: [] },
      ]
    }
  }
  ```
 * `idx(['user', 'posts', 0, 'comments'], props)` would return `[ 'Good one!', 'Interesting...' ]`
 */
export const idx = (p: Array<any>, o: object): any => {
  if (isNullOrUndefined(p)) {
    return null;
  }
  return p.reduce((xs, x) => (isNullOrUndefined(xs) || isNullOrUndefined(xs[x]) ? null : xs[x]), o);
};

// TODO: Make this a class with static methods
export function isDateWithinNMinutesOfNow(date: Moment, minutes: number): boolean {
  const timeDifferenceInMinutes = date.diff(moment(), 'minutes');
  return timeDifferenceInMinutes < minutes;
}

export function hasExpirationDatePassed(month: number, year: number): boolean {
  const currentDate: Date = new Date();
  const currentYear: number = currentDate.getFullYear();
  const currentMonth: number = currentDate.getMonth() + 1;

  if (currentYear === year) {
    return month < currentMonth;
  }

  return year < currentYear;
}

export function adjustDateFromLocalToUTC(date: Date): Date {
  return moment(date).add(date.getTimezoneOffset(), 'minutes').toDate();
}
